var _clipPath, _clipPath2, _clipPath3, _clipPath4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNsgWeyland = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 1056 1056"
}, props), /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "NSG_WEYLAND_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "m264.755 429.711 33.177 88.66h193.805l33.168-88.655 31.288 82.485-161.358 184.903-161.363-184.908ZM624.41 55.831H165.23L46.419 367.198l696.821 2.136Z"
}))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "NSG_WEYLAND_svg__c",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "m233.472 512.196 31.283-82.485 33.177 88.66h193.805l33.168-88.655 31.289 82.485-161.359 184.902zM46.419 367.198 165.23 55.831h459.18l118.83 313.503z"
}))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "NSG_WEYLAND_svg__d",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-118.87 715.06H908.529V47.04H-118.87Z"
}))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "NSG_WEYLAND_svg__e",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M907.233 48.335H-118.869V47.04H907.233Zm0 9.811H-118.869v-4.145H907.233Zm1.295 17.305H-118.87V72.86H908.528Zm-1.295 15.857H-118.87v-5.183H907.233Zm0 12.816H-118.87v-1.554H907.233Zm0 7.272H-118.87v-2.592H907.233Zm0 11.471H-118.869v-4.146H907.233Zm0 12.515H-118.869v-1.037H907.233Zm0 15.494H-118.87v-3.887H907.233Zm0 19.214H-118.87v-2.591H907.233Zm0 13.295H-118.869v-1.037H907.233Zm0 10.906H-118.87V191.7H907.233Zm0 21.825H-118.87v-5.183H907.233Zm0 13.601H-118.869v-1.295H907.233Zm0 9.81H-118.869v-4.145H907.233Zm1.295 17.306H-118.87v-2.591H908.528Zm-1.295 15.855H-118.87v-5.182H907.233Zm0 12.818H-118.87v-1.554H907.233Zm0 7.272H-118.87v-2.592H907.233Zm0 11.471H-118.869v-4.146H907.233Zm0 12.515H-118.869v-1.037H907.233Zm0 15.494H-118.87v-3.887H907.233Zm0 19.214H-118.87v-2.591H907.233Zm0 13.295H-118.869v-1.037H907.233Zm0 10.906H-118.87v-2.591H907.233Zm0 21.825H-118.87v-5.182H907.233Zm0 13.601H-118.869v-1.295H907.233Zm0 9.81H-118.869v-4.145H907.233Zm1.295 17.306H-118.87v-2.591H908.528Zm-1.295 15.856H-118.87v-5.183H907.233Zm0 12.816H-118.87v-1.554H907.233Zm0 7.273H-118.87v-2.591H907.233Zm0 11.47H-118.869v-4.145H907.233Zm0 12.516H-118.869v-1.038H907.233Zm0 15.494H-118.87v-3.887H907.233Zm0 19.214H-118.87v-2.591H907.233Zm0 13.294H-118.869v-1.038H907.233Zm0 10.907H-118.87v-2.591H907.233Zm0 21.824H-118.87v-5.182H907.233Zm0 13.601H-118.869v-1.295H907.233Zm0 9.811H-118.869v-4.145H907.233Zm1.295 17.306H-118.87v-2.591H908.528Zm-1.295 15.856H-118.87v-5.183H907.233Zm0 12.816H-118.87v-1.554H907.233Zm0 7.273H-118.87v-2.591H907.233Zm0 11.47H-118.869v-4.145H907.233Zm0 12.516H-118.869v-1.038H907.233Zm0 15.493H-118.87v-3.887H907.233Zm0 11.271H649.668v-2.591h257.565zm0 7.473H657.899v1.295h249.334z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "NSG_WEYLAND_svg__b",
  x1: 0,
  x2: 1,
  y1: 0,
  y2: 0,
  gradientTransform: "scale(641.27209 -641.27209)rotate(90 .851 -.236)",
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopOpacity: 1,
    stopColor: "#bcbec0"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopOpacity: 1,
    stopColor: "#414142"
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "NSG_WEYLAND_svg__f",
  x1: 0,
  x2: 1,
  y1: 0,
  y2: 0,
  gradientTransform: "scale(668.02051 -668.02051)rotate(90 .83 -.24)",
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopOpacity: 1,
    stopColor: "#e7e8e9"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  style: {
    stopOpacity: 1,
    stopColor: "#e7e8e9"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.453,
  style: {
    stopOpacity: 1,
    stopColor: "#bcbec0"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  style: {
    stopOpacity: 1,
    stopColor: "#939598"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopOpacity: 1,
    stopColor: "#939598"
  }
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NSG_WEYLAND_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 1056)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m264.755 429.711 33.177 88.66h193.805l33.168-88.655 31.288 82.485-161.358 184.903-161.363-184.908ZM624.41 55.831H165.23L46.419 367.198l696.821 2.136Z",
  style: {
    fill: "url(#NSG_WEYLAND_svg__b)",
    stroke: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NSG_WEYLAND_svg__c)",
  transform: "matrix(1.33333 0 0 -1.33333 0 1056)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NSG_WEYLAND_svg__d)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NSG_WEYLAND_svg__e)",
  opacity: 0.15
}, /*#__PURE__*/React.createElement("path", {
  d: "M907.233 48.335H-118.869V47.04H907.233Zm0 9.811H-118.869v-4.145H907.233Zm1.295 17.305H-118.87V72.86H908.528Zm-1.295 15.857H-118.87v-5.183H907.233Zm0 12.816H-118.87v-1.554H907.233Zm0 7.272H-118.87v-2.592H907.233Zm0 11.471H-118.869v-4.146H907.233Zm0 12.515H-118.869v-1.037H907.233Zm0 15.494H-118.87v-3.887H907.233Zm0 19.214H-118.87v-2.591H907.233Zm0 13.295H-118.869v-1.037H907.233Zm0 10.906H-118.87V191.7H907.233Zm0 21.825H-118.87v-5.183H907.233Zm0 13.601H-118.869v-1.295H907.233Zm0 9.81H-118.869v-4.145H907.233Zm1.295 17.306H-118.87v-2.591H908.528Zm-1.295 15.855H-118.87v-5.182H907.233Zm0 12.818H-118.87v-1.554H907.233Zm0 7.272H-118.87v-2.592H907.233Zm0 11.471H-118.869v-4.146H907.233Zm0 12.515H-118.869v-1.037H907.233Zm0 15.494H-118.87v-3.887H907.233Zm0 19.214H-118.87v-2.591H907.233Zm0 13.295H-118.869v-1.037H907.233Zm0 10.906H-118.87v-2.591H907.233Zm0 21.825H-118.87v-5.182H907.233Zm0 13.601H-118.869v-1.295H907.233Zm0 9.81H-118.869v-4.145H907.233Zm1.295 17.306H-118.87v-2.591H908.528Zm-1.295 15.856H-118.87v-5.183H907.233Zm0 12.816H-118.87v-1.554H907.233Zm0 7.273H-118.87v-2.591H907.233Zm0 11.47H-118.869v-4.145H907.233Zm0 12.516H-118.869v-1.038H907.233Zm0 15.494H-118.87v-3.887H907.233Zm0 19.214H-118.87v-2.591H907.233Zm0 13.294H-118.869v-1.038H907.233Zm0 10.907H-118.87v-2.591H907.233Zm0 21.824H-118.87v-5.182H907.233Zm0 13.601H-118.869v-1.295H907.233Zm0 9.811H-118.869v-4.145H907.233Zm1.295 17.306H-118.87v-2.591H908.528Zm-1.295 15.856H-118.87v-5.183H907.233Zm0 12.816H-118.87v-1.554H907.233Zm0 7.273H-118.87v-2.591H907.233Zm0 11.47H-118.869v-4.145H907.233Zm0 12.516H-118.869v-1.038H907.233Zm0 15.493H-118.87v-3.887H907.233Zm0 11.271H649.668v-2.591h257.565zm0 7.473H657.899v1.295h249.334z",
  style: {
    fill: "url(#NSG_WEYLAND_svg__f)",
    stroke: "none"
  }
})))), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 109.333 288.447-660.566-2.025L-441.941 0Zm-459.16-25-128.328 336.312 733.075 2.247L17.26-25Z",
  style: {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 821.04 964.892)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 653.315 2.002-107.434-283.436H107.389Zm696.821 32.137-7.267-.023L-36.27 29.89l-7.236-.023 2.58-6.76L85.499-308.216l1.227-3.218h479.868l1.224 3.228L694.246 25.342zM660.566 7.024-7.251 4.978l111.196-291.412h445.388zm29.004 20.09L563.142-306.434H90.17L-36.255 24.89Z",
  style: {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 90.897 586.314)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h455.733l116.931 308.492-689.571-2.114zm459.184-5H-3.443l-.615 1.608-120.1 314.748 3.618.011 700.454 2.147z",
  style: {
    fill: "#dcdbdb",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 222.602 978.225)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-7.289 19.493h-183.399L-197.979.002l-31.044-83.003-39.934 105.364 169.97 194.769-169.97-194.769 39.934-105.364L-197.979.002l7.291 19.491H-7.289zl31.035-82.999Zm31.163-26.238L18.733 7.005l-7.289 19.493-4.859 12.995h-211.147l-4.859-12.994-7.29-19.491-12.436-33.25-16.86 44.485 147.02 168.471L48.027 18.249Zm-130.15 250.974L-274.694 23.393l45.702-120.585 41.772 111.685h176.462L31.003-97.189 76.715 23.397Z",
  style: {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 658.43 400.829)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-7.289 19.493h-183.399L-197.979.002l-31.044-83.003-39.934 105.364 169.97 194.769-169.97-194.769 39.934-105.364L-197.979.002l7.291 19.491H-7.289L0 0l31.035-82.999Zm31.163-26.238L18.733 7.005l-7.289 19.493-4.859 12.995h-211.147l-4.859-12.994-7.29-19.491-12.436-33.25-16.86 44.485 147.02 168.471L48.027 18.249Zm-130.15 250.974L-274.694 23.393l45.702-120.585 41.772 111.685h176.462L31.003-97.189 76.715 23.397Z",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "matrix(1.33333 0 0 -1.33333 658.43 400.829)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 28.398-74.879L59.857 9.189h197.274l31.45-84.064L316.983.005 158.494 181.62Zm28.43-89.062L-5.738 1.029l164.232 188.195L322.722 1.034l-34.174-90.091-34.886 93.246H63.325Z",
  style: {
    fill: "#dcdbdb",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 315.121 373.758)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-108.254-285.569-72.688 194.394h-114.032l-72.707-194.393L-475.913 0h-107.238l158.803-418.952h114.071l72.317 193.384 72.326-193.384h114.069L107.241 0Z",
  style: {
    fill: "#516751",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 843.72 319.939)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h114.068l158.807 418.952H165.634L57.38 133.383l-72.689 194.394H-129.34l-72.707-194.393-108.232 285.568h-107.239L-258.714 0h114.07l72.317 193.384zm-13.873-20-58.453 156.288L-130.77-20h-141.752l-173.965 458.952h150.016l94.3-248.808 58.958 157.633H-1.434l58.943-157.632 94.318 248.807h150.018L127.876-20Z",
  style: {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 622.875 878.542)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 103.36 272.658-13.807 20L-18.701 7.089v-56.423z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 724.316 710.15)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-103.359 272.658 13.807 20L18.702 7.089l-.001-56.423Z",
  style: {
    fill: "#3f4f3f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 329.035 710.15)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-72.707-194.394-.051.135v-56.432l.175-.462 18.609 49.754L13.873-20Z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 450.421 441.505)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 72.707-194.394.051.135v-56.432l-.175-.462-18.609 49.754L-13.873-20Z",
  style: {
    fill: "#3f4f3f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 602.583 441.505)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 13.873-20h86.286l13.873 20z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 450.421 441.505)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 14.26 20h86.389l13.422-20Z",
  style: {
    fill: "#2c382c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 277.923 878.542)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 28.97 20-158.679-418.952-13.422 20z",
  style: {
    fill: "#2c382c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 948.082 346.605)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-28.97 20 158.679-418.952 13.422 20z",
  style: {
    fill: "#3f4f3f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 105.353 346.605)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-58.259l-72.327-193.384-13.422 20z",
  style: {
    fill: "#2c382c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 526.44 543.018)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-58.259l72.327-193.384 13.422 20z",
  style: {
    fill: "#3f4f3f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 526.44 543.018)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 14.268 20h86.389l13.411-20Z",
  style: {
    fill: "#2c382c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 622.875 878.542)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 13.808-20h64.463l28.97 20z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 843.72 319.939)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-13.807-20h-64.464l-28.97 20z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 209.173 319.939)"
}));
export default SvgNsgWeyland;